const formatSerialNumber = serialNumber =>
	!/[_-]/.test(serialNumber) // if contains dash or underscore skip formatting
		? serialNumber.replace(/(.{4})/g, "-$1").slice(1)
		: serialNumber;

export default formatSerialNumber;
